const complainId = state => state.complainId;

const complainLoading = state => state.complainLoading;

const complainPhoto = state => state.complainPhoto;

const complainPhotoLoading = state => state.complainPhotoLoading;

export default {
  complainId,
  complainLoading,
  complainPhoto,
  complainPhotoLoading
};
